<template>
    <div class="row hide">
        <div class="col-md-12">
            <div class="card card-shadow printableArea" id="printMe">
                <div class="card-header border-bottom">
                    <div class="d-md-flex align-items-center m-t-20">
                        <div class="d-flex align-items-center">
                            <div>
                                <h3 class="font-medium m-b-2">Test Report</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-blue card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row" v-for="record in did_records">
                                <div :class="{'font-weight-bold': record.name === 'Batch No.'}"
                                     class="col-sm-4 col-lg-4">{{record.name}}
                                </div>
                                <div :class="{'font-weight-bold': record.name === 'Batch No.'}"
                                     class="col-sm-8 col-lg-8">: {{record.fact.value}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body" v-if="service_list.length>0">
                    <h4 class="card-title mb-4">Test Results</h4>
                    <template v-for="(service, index) in service_list">
                        <div :class="{'mt-5': service.name === 'Others'}" class="card card-border"
                             v-for="(claim, index2) in service.items">
                            <div class="card-header bg-grey card-header-border p-1">
                                <div style="cursor: pointer">
                                    <h6 class="card-title ml-2 mt-2">
                                        {{service.name}}&nbsp;Report&nbsp;#{{index2+1}}</h6>
                                    <p class="card-subtitle ml-2 mb-2" v-if="claim.description">({{claim.description |
                                        capitalize}})</p>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row"
                                     v-for="claim in claim.items">
                                    <label class="col-sm-5 control-label">{{claim.name}}</label>
                                    <div class="col-sm-7">
                                        <p class="form-control-static">
                                            {{claim.fact.value}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="card-blue card-body">
                    <div class="row">
                        <div class="text-right" style="margin-left: 75%">
                            <img :src="qrUrl" alt="" v-if="qrUrl">
                            <p class="text-muted font-weight-bold">(Scan QR to view on Blockchain)</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import moment from "moment";
    import QRCode from "qrcode";
    import ProfileByPublicKey from "../../../../common/ProfileByPublicKey";
    import ClaimAttachments from "../../../growers/action/sections/ClaimAttachments";

    export default {
        name: "PrintQualityReport",
        components: {ClaimAttachments, ProfileByPublicKey},
        props: ['org', 'claims', 'did_records', 'reports', 'did', 'table_headers', 'service_list'],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                qrUrl: null,
            }
        },
        mounted() {
            this.generateQr()
        },
        methods: {
            async generateQr() {
                let qr = 'https://www.maya.explorer.borlaug.network/identity/did:bws:' + this.did.substring(2, this.did.length);

                this.qrUrl = await QRCode.toDataURL(qr, {
                    width: 200,
                    type: 'svg',
                    color: {
                        dark: '#3e5569',  // Blue dots
                        light: '#0000' // Transparent background
                    }
                });
            }
        }
    }
</script>

<style scoped>
    @media print {
        div {
            page-break-after: always;
        }
    }
</style>

